import { createPerimeter } from 'vue-kindergarten';
import { isLoggedIn } from '../utilities/roleUtilities';

export const WelcomePerimeter = createPerimeter({
    purpose: 'welcome',
    can: {
        read () {
            return isLoggedIn(this.child);
        }
    }
});
